import { render, staticRenderFns } from "./login.vue?vue&type=template&id=996dd1c6&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=996dd1c6&prod&lang=css&"
import style1 from "./login.vue?vue&type=style&index=1&id=996dd1c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996dd1c6",
  null
  
)

export default component.exports